export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5943.51fb5577.jpg";